import React, { useState, useEffect } from "react";
import { Modal, ConfigProvider, Button, message, List, Typography, Spin, Table } from 'antd';
import { getMilestoneHistoryApi } from '@/services';
import { useRequest } from "ahooks";
import { parseTime } from '@/utils';
import { getMilestoneStatusLabel } from "./edit"

interface IProps {
    projectID: number | string;
    plotID?: number,
    milestoneNode?: API.PROJECT.Milestone;
    visible: boolean;
    onClose: () => void;
}

const Index: React.FC<IProps> = ({ projectID, plotID, milestoneNode, onClose, visible }) => {
    const [modalApi, modalContextHolder] = Modal.useModal();
    const [messageApi, contextHolder] = message.useMessage();
    
    // 使用useRequest获取里程碑历史数据
    const { data, loading, refresh } = useRequest(() => 
        getMilestoneHistoryApi(projectID, milestoneNode?.milestoneCode || "", plotID), 
        {
            manual: true,
            onError: (error) => {
                messageApi.error("获取历史记录失败");
                console.error("获取里程碑历史失败:", error);
            }
        }
    );
    
    // 当模态框显示时获取数据
    useEffect(() => {
        if (visible && projectID && milestoneNode && milestoneNode.milestoneCode) {
            refresh();
        }
    }, [visible, projectID, milestoneNode, refresh]);
    
    // 表格列配置
    const columns = [
        {
            title: '编辑时间',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (text: string) => parseTime(text),
            width: 180,
        },
        {
            title: '里程碑计划时间',
            dataIndex: 'standardDate',
            key: 'standardDate',
            width: 120,
        },
        {
            title: '里程碑完成时间',
            dataIndex: 'actualDate',
            key: 'actualDate',
            width: 120,
        },
        {
            title: '里程碑状态',
            dataIndex: 'status',
            key: 'status',
            render: (status: number) => getMilestoneStatusLabel(status),
            width: 100,
        },
        {
            title: '修改人',
            dataIndex: ["opUser","lastname"],
            width: 100,
        },
    ];
    
    return (
        <ConfigProvider
            theme={{
                token: {
                    fontSize: 12
                },
            }}
        >
            {modalContextHolder}
            {contextHolder}
            <Modal 
                open={visible}
                footer={null}
                destroyOnHidden={true}
                onCancel={onClose}
                width={800}
                style={{ minWidth: 520 }}
                title={`${milestoneNode?.milestoneName || ""} - 里程碑计划编辑历史`}
            >
                <div className="min-h-[300px] max-h-[600px] overflow-hidden">
                    {loading ? (
                        <div className="flex justify-center items-center h-[300px]">
                            <Spin size="large" tip="加载中..." />
                        </div>
                    ) : !data || data?.length === 0 ? (
                        <div className="flex justify-center items-center h-[300px] text-gray-500">
                            暂无历史记录
                        </div>
                    ) : (
                        <Table 
                            columns={columns}
                            dataSource={data}
                            rowKey="index"
                            scroll={{ y: 500 }}
                            pagination={false}
                            size="small"
                        />
                    )}
                </div>
            </Modal>
        </ConfigProvider>
    );
};

export default Index;